const featuredImageElement = document.getElementById('current-product-image');
const thumbnails = document.querySelectorAll('.product-thumbnails .thumbnail');
const slider = document.querySelector('.thumbnail-slider');
let currentImageIndex = 0;
const images = Array.from(thumbnails).map(thumbnail => thumbnail.dataset.imageUrl);

function updateImage(index) {
    if (featuredImageElement) {
        featuredImageElement.src = images[index];
    } else {
        console.error("Element with id 'current-product-image' not found.");
    }
}

// Arrow navigation for the featured image
function prevArrowClick() {
    currentImageIndex = (currentImageIndex === 0) ? images.length - 1 : currentImageIndex - 1;
    updateImage(currentImageIndex);
}

function nextArrowClick() {
    currentImageIndex = (currentImageIndex === images.length - 1) ? 0 : currentImageIndex + 1;
    updateImage(currentImageIndex);
}

// Clicking on thumbnails to change the featured image
thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function(e) {
        e.preventDefault();
        currentImageIndex = index;
        updateImage(currentImageIndex);
    });
});

// Slider logic
let currentSlide = 0;
const visibleThumbnails = 4; // Number of thumbnails visible at once
const maxSlides = thumbnails.length;
const slideWidth = thumbnails[0].offsetWidth + 10; // Thumbnail width + margin

function updateSliderPosition() {
    slider.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
}

function nextSliderArrow() {
    if (currentSlide < maxSlides - visibleThumbnails) {
        currentSlide++;
        updateSliderPosition();
    }
}

function prevSliderArrow() {
    if (currentSlide > 0) {
        currentSlide--;
        updateSliderPosition();
    }
}

// Touch/swipe logic
let touchStartX = 0;
let touchEndX = 0;
const swipeThreshold = 30; // Minimum distance for swipe to be considered

featuredImageElement.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
});

featuredImageElement.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
});

function handleSwipe() {
    const distanceSwiped = touchEndX - touchStartX;
    if (Math.abs(distanceSwiped) > swipeThreshold) { 
        if (distanceSwiped < 0) {
            nextArrowClick();
        } else {
            prevArrowClick();
        }
    }
}

const featuredImageWrapper = document.querySelector('.product-featured-image');

// Mouse enter: Activate zoom and scale the image
featuredImageWrapper.addEventListener('mouseenter', () => {
  featuredImageElement.style.transform = 'scale(2)'; // Double the image size for zoom effect
});

// Mouse move: Update the position of the zoomed image
featuredImageWrapper.addEventListener('mousemove', (e) => {
  const rect = featuredImageWrapper.getBoundingClientRect();
  const x = e.clientX - rect.left; // X position within the image container
  const y = e.clientY - rect.top;  // Y position within the image container

  // Calculate the transform origin based on cursor position
  const xPercent = (x / rect.width) * 100;
  const yPercent = (y / rect.height) * 100;

  featuredImageElement.style.transformOrigin = `${xPercent}% ${yPercent}%`;
});

// Mouse leave: Reset zoom and position
featuredImageWrapper.addEventListener('mouseleave', () => {
  featuredImageElement.style.transform = 'scale(1)';
  featuredImageElement.style.transformOrigin = 'center';
});